import React from "react";

import Banner from "../../../assets/images/backgrounds/banner-seguro-multirrisco-desktop.png";
import BannerMobile from "../../../assets/images/backgrounds/banner-seguro-multirrisco-mobile.png";
import HeroSection from "../../../components/Habitacional/HeroSection";
import AdvantagesSection from "../Sections/AdvantagesSection/AdvantagesSection";
import CoverageSection from "../../../components/common/CoverageSection/CoverageSection";
import AssistanceServiceSection from "../Sections/AssistanceServiceSection/AssistanceServiceSection";
import HireSection from "../Sections/HireSection/HireSection";
import ActivateInsuranceSection from "../Sections/ActivateInsuranceSection/ActivateInsuranceSection";
import FaqSection from "../Sections/FaqSection/FaqSection";
import DocumentsSection from "../Sections/DocumentsSection/DocumentsSection";

import {
  MultiRiskAdvantageList,
  MultiRiskCoverageList,
  MultiRiskDocumentList,
  MultiRiskfaqList,
} from "../Constants/BusinessMultiRisk.constants";

export const BusinessMultiRisk = () => {
  return (
    <>
      <HeroSection
        backgroundImageDesktop={Banner}
        backgroundImageMobile={BannerMobile}
        primarySubtitle="Seguro Multirrisco"
        mainTitle="Empresarial"
      />
      <AdvantagesSection advantagesList={MultiRiskAdvantageList} />
      <CoverageSection
        textsList={[
          {
            id: "1-text",
            title: "Cuidado sob medida para o seu negócio",
            description: (
              <>
                Já pensou em ter um seguro que realmente combina com a sua
                empresa? Com o Multirrisco Empresarial isso é possível. Você tem
                flexibilidade para escolher as coberturas que fazem mais sentido
                para o seu negócio, levando em conta as particularidades e
                desafios que ela tem. Assim, cuidamos das suas conquistas para
                você focar em crescer ainda mais, com tranquilidade e segurança.
              </>
            ),
          },
          {
            id: "2-text",
            title: "Coberturas",
            description: (
              <>
                Com o <strong>Seguro Multirrisco Empresarial</strong>,
                garantimos a segurança do seu negócio em várias{" "}
                <strong>situações inesperadas</strong> Confira as principais
                coberturas!
              </>
            ),
          },
        ]}
        coverageList={MultiRiskCoverageList}
      />
      <AssistanceServiceSection serviceName="Seguro Multirrisco Empresarial" />
      <HireSection
        description={
          <>
            Visite sua agência Caixa e peça pelo Seguro Empresarial Multirrisco
            da Caixa Seguradora. O gerente vai te ajudar a escolher os
            benefícios mais adequados para a realidade do seu negócio.
          </>
        }
      />
      <ActivateInsuranceSection />
      <FaqSection
        faqTitle="Multirrisco Empresarial"
        faqList={MultiRiskfaqList}
      />
      <DocumentsSection
        documentType="Seguro Multirrisco Empresarial"
        documentList={MultiRiskDocumentList}
      />
    </>
  );
};
